<div class="avatar" [style.width]="size" [style.height]="size" [style.lineHeight]="size" [style.backgroundColor]="!photo ? backgroundColor : 'transparent'">
    <ng-container *ngIf="!photo; else showPhoto">{{ initials }}</ng-container>
    <ng-template #showPhoto>
        <img [attr.src]="photo" [attr.width]="size" [attr.height]="size" [style.width]="size" />
    </ng-template>
</div>
